
(function ($) {

  $(document).ready(function () {
    $('.js-slider').slick({
      prevArrow: '<button type="button" class="slider__prev">Previous</button>',
      nextArrow: '<button type="button" class="slider__next">Next</button>',
    });
  });

})(jQuery);
